import { useContext } from 'react';
import { OmniCallContext, OmniCallContextProps } from './OmniCallProvider';

export const useOmniCallContext = (): OmniCallContextProps => {
  const context = useContext(OmniCallContext);
  if (!context) {
    throw new Error('useOmniCallContext must be used within a CustomerChatContext');
  }
  return context;
};
